
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/me/directive/will/tutorial",
      function () {
        return require("private-next-pages/me/directive/will/tutorial.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/me/directive/will/tutorial"])
      });
    }
  